@if (task) {
  <div class="form-container">
    <qform-form-header
      [title]="taskTitle"
      [subtitle]="taskSubtitle"
      [dropdownItems]="headerDropdownUrls"
      [isGuest]="isGuest"
      [timeZone]="guestTimeZone"></qform-form-header>

    <div class="form-render-content">
      <app-form-render-component
        [formComponents]="formComponents"></app-form-render-component>
    </div>

    @if (canRespond) {
      <qform-buttons-container
        [buttonsList]="task.responsesConfiguration.responses ?? []"
        (optionSelected)="respondTask($event)"></qform-buttons-container>
    } @else {
      @if (currentTaskResponse) {
        <div class="form-render-content current-response-container">
          <span> {{ 'TheSelectedResponseIs' | localize }}: </span>
          <span class="current-response">{{
            currentTaskResponse?.value ?? ''
          }}</span>
        </div>
      }
    }
  </div>
}
